/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_Filter_EmptyInputs */

const en_admin_user_list_mail_filter_empty = /** @type {(inputs: Admin_User_List_Mail_Filter_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users match the current filters.`)
};

const de_admin_user_list_mail_filter_empty = /** @type {(inputs: Admin_User_List_Mail_Filter_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Nutzer entsprechen der aktuellen Filterauswahl.`)
};

/**
* | output |
* | --- |
* | "No users match the current filters." |
*
* @param {Admin_User_List_Mail_Filter_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_filter_empty = /** @type {((inputs?: Admin_User_List_Mail_Filter_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_Filter_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_filter_empty(inputs)
	return en_admin_user_list_mail_filter_empty(inputs)
});